module.exports = __webpack_public_path__ + "static/media/logo8.ff5e1d9e.png";